import Constants from "../../utils/Constants";
const shared = {
	black: "#000",
	blue: "#4c56c0",
	orange: "#f1682c",
	green: "#6cbd7e",
	red: "#D61D1D",
	yellow: "#FFD600",
	white: "#fff",
	pink: "#FF3FB5",
	all: "#FFFFFF",
	positive: "#62cf6b",
	error: "#fd416a",
	button: "#A030DD",
	buttonSecondary: "#AE1CE1",
	activeTintColor: "#5D86C9",
	inactiveTintColor: "#868686",
	searchBorder: "#7AC1E4",
	activeTab: "#22D2B9",
};

const VivoShades = {
	50: "#eef0f7",
	100: "#cbd1e7",
	200: "#a8b2d7",
	300: "#8593c7",
	400: "#6274b7",
	500: "#485b9d",
	600: "#38477a",
	700: "#283357",
	800: "#181e34",
	900: "#080a11",
};

const HuaweiShades = {
	50: "#fce9ea",
	100: "#f09c9f",
	200: "#ee9194",
	300: "#ec8689",
	400: "#e24349",
	500: "#c71f25",
	600: "#de2d34",
	700: "#bc1d23",
	800: "#d22127",
	900: "#a51a1f",
};

const XiaomiShades = {
	50: "#feefe7",
	100: "#fbceb7",
	200: "#fbceb7",
	300: "#f58e56",
	400: "#f26d26",
	500: "#d9540d",
	600: "#f15d0e",
	700: "#d1510c",
	800: "#c94e0c",
	900: "#933909",
};

const HisenseShades = {
	50: "#e5fffe",
	100: "#b3fffd",
	200: "#80fffc",
	300: "#14fff9",
	400: "#00d6d1",
	500: "#00c2bd",
	600: "#00ada9",
	700: "#009995",
	800: "#008581",
	900: "#00706e",
};

const DefaultShades = {
	50: "#eef0f7",
	100: "#cbd1e7",
	200: "#a8b2d7",
	300: "#8593c7",
	400: "#8d9bcb",
	500: "#7c8cc3",
	600: "#5a6eb3",
	700: "#5a6eb3",
	800: "#435492",
	900: "#3a497e",
};

const colors = {
	vivo: {
		primary: "#5065af",
		secondary: "#4075af",
		danger: "#fd416a",
		text: "#282C34",
		altText: "#9FA0A2",
		warning: "#f1682c",
		card: "#fff",
		border: "rgb(216, 216, 216)",
		notification: "#FF3FB5",
		background: "rgb(242, 242, 242)",
		...shared,
	},
	huawei: {
		primary: "#c71f25",
		secondary: "#940500",
		danger: "#fd416a",
		text: "#282C34",
		altText: "#9FA0A2",
		warning: "#f1682c",
		card: "#fff",
		border: "rgb(216, 216, 216)",
		notification: "#FF3FB5",
		background: "rgb(242, 242, 242)",
		...shared,
	},
	Xiaomi: {
		primary: "#f26a21",
		secondary: "#f58e56",
		danger: "#fd416a",
		text: "#282C34",
		altText: "#9FA0A2",
		warning: "#f1682c",
		card: "#fff",
		border: "rgb(216, 216, 216)",
		notification: "#FF3FB5",
		background: "rgb(242, 242, 242)",
		...shared,
	},
	Hisense: {
		primary: "#00aaa6",
		secondary: "#4dfffb",
		danger: "#fd416a",
		text: "#282C34",
		altText: "#9FA0A2",
		warning: "#f1682c",
		card: "#fff",
		border: "rgb(216, 216, 216)",
		notification: "#FF3FB5",
		background: "rgb(242, 242, 242)",
		...shared,
	},
};

export const getTheme = (URL) => {
	switch (URL) {
		case Constants.VivoURL:
			return colors.vivo;
		case Constants.XiaomiURL:
			return colors.Xiaomi;
		case Constants.HisenseURL:
			return colors.Hisense;

		default:
			return colors.Hisense;
	}
};

export const getShades = (URL) => {
	switch (URL) {
		case Constants.VivoURL:
			return VivoShades;
		case Constants.XiaomiURL:
			return XiaomiShades;
		case Constants.HisenseURL:
			return HisenseShades;

		default:
			return HisenseShades;
	}
};
